import { RouterProvider, type RouterProviderProps } from 'react-router-dom';

export function AppProviders({ router }: RouterProviderProps) {
  return <RouterProvider router={router} />;
}
